import type { ListItemNode, ListItemTextNode } from '@prezly/story-content-format';
import { ListNode, TextAlignment } from '@prezly/story-content-format';
import classNames from 'classnames';
import type { PropsWithChildren } from 'react';

import styles from './styles.module.scss';

interface ListProps {
    node: ListNode;
}

export function List({ node, children }: PropsWithChildren<ListProps>) {
    const className = classNames({
        [styles.numberedList]: node.type === ListNode.Type.NUMBERED,
        [styles.orderedList]: node.type === ListNode.Type.BULLETED,
        [styles.alignLeft]: node.align === TextAlignment.LEFT,
        [styles.alignCenter]: node.align === TextAlignment.CENTER,
        [styles.alignRight]: node.align === TextAlignment.RIGHT,
        [styles.alignJustify]: node.align === TextAlignment.JUSTIFY,
    });

    if (node.type === ListNode.Type.NUMBERED) {
        return <ol className={className}>{children}</ol>;
    }

    return <ul className={className}>{children}</ul>;
}

interface ListItemProps {
    node: ListItemNode;
}

export function ListItem({ children }: PropsWithChildren<ListItemProps>) {
    return <li className={styles.listItem}>{children}</li>;
}

interface ListItemTextProps {
    node: ListItemTextNode;
}

export function ListItemText({ children }: PropsWithChildren<ListItemTextProps>) {
    return <>{children}</>;
}
